import React from 'react';
import {
    StyledTopBar,
    StyledTopBarContainer,
    TopBarMain,
    TopBarVisuallyLeft,
    TopBarVisuallyRight,
} from './TopBar.styles';
import ProgramInfo from './components/ProgramInfo';
import BackButton from './components/BackButton';
import EpisodePickerButton from '../EpisodePickerButton/EpisodePickerButton';

export type TopBarProps = {
    title?: string;
    episodeTitle?: string;
    noGradient?: boolean;
    url?: string;
    videos?: any;
    selectedVideoId?: string;
    parentUrl?: string;
    setDisplayEpisodePicker?: any;
    displayEpisodePicker?: boolean;
    showEpisodePickerButton?: boolean;
    playedPercentage?: number;
};

const TopBar = ({
    title,
    episodeTitle,
    noGradient = false,
    url,
    videos,
    selectedVideoId,
    parentUrl,
    setDisplayEpisodePicker,
    displayEpisodePicker,
    showEpisodePickerButton,
    playedPercentage,
}: TopBarProps) => (
    <StyledTopBarContainer noGradient={noGradient}>
        <StyledTopBar justifyEnd={displayEpisodePicker}>
            {displayEpisodePicker ? (
                <>
                    <TopBarVisuallyLeft />
                    <TopBarMain />
                </>
            ) : (
                <>
                    <TopBarVisuallyLeft>
                        <BackButton />
                    </TopBarVisuallyLeft>
                    <TopBarMain>
                        <ProgramInfo
                            title={title}
                            episodeTitle={episodeTitle}
                            url={url}
                            videos={videos}
                            selectedVideoId={selectedVideoId}
                            parentUrl={parentUrl}
                        />
                    </TopBarMain>
                </>
            )}
            {showEpisodePickerButton && (
                <TopBarVisuallyRight displayEpisodePicker={displayEpisodePicker}>
                    {
                        <EpisodePickerButton
                            setDisplayEpisodePicker={setDisplayEpisodePicker}
                            displayEpisodePicker={displayEpisodePicker}
                            playedPercentage={playedPercentage}
                        />
                    }
                </TopBarVisuallyRight>
            )}
        </StyledTopBar>
    </StyledTopBarContainer>
);

export default TopBar;
